<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedications">
<h1 style="padding-bottom:0px;font-size:20px;letter-spacing:0px;">Dedications</h1>
<p style="text-align: center;">Ian Sellers and Elsie Whittington.</p><br/>
<p style="text-align: center;">My mother and father to whom I owe everything.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?85fc51f4